import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITeamMember, ITeamMemberInitialState } from "./teamMemberModel";
import {
  ActiveInactiveTeamMember,
  createTeamMember,
  deleteTeamMember,
  getAllActiveTeamMember,
  getAllTeamMember,
  getTeamMemberByID,
  TeamMemberImageUpload,
  updateTeamMember,
} from "./services/teamMember.services";

const initialState: ITeamMemberInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TeamMemberList: [],
  TeamMemberID: null,
  TeamMemberDetail: {
    SequenceNo: null,
    Name: "",
    Designation: "",
    Facebook: "",
    xlink: "",
    Linkedin: "",
    InstaLink: "",
    IsActive: 1,
  },
};

const teamMemberSlice = createSlice({
  name: "teammember",
  initialState,
  reducers: {
    clearTeamMemberDetail: (state) => {
      state.TeamMemberDetail = initialState.TeamMemberDetail;
    },
    setTeamMemberID: (state, action) => {
      state.TeamMemberID = action.payload;
    },
    clearTeamMemberID: (state) => {
      state.TeamMemberID = initialState.TeamMemberID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTeamMember.fulfilled,
      (state, action: PayloadAction<ITeamMember[]>) => {
        state.loading = false;
        state.TeamMemberList = action.payload || [];
      }
    );
    builder.addCase(getAllTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TeamMemberList = [];
    });
    builder.addCase(createTeamMember.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createTeamMember.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTeamMember.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTeamMember.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTeamMember.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTeamMember.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTeamMember.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTeamMemberByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTeamMemberByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TeamMemberDetail = action.payload;
    });
    builder.addCase(getTeamMemberByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TeamMemberDetail = initialState.TeamMemberDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTeamMember.fulfilled,
      (state, action: PayloadAction<ITeamMember[]>) => {
        state.loading = false;
        state.TeamMemberList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TeamMemberList = [];
    });
    builder.addCase(ActiveInactiveTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTeamMember.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(TeamMemberImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(TeamMemberImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(TeamMemberImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTeamMemberDetail, clearTeamMemberID, setTeamMemberID } =
  teamMemberSlice.actions;
export default teamMemberSlice.reducer;
